// https://github.com/reactjs/redux/issues/99
// import { canUseDOM } from 'exenv';

export default function(state = {}, action) {
  const typeMap = {
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADING() {
      return {
        isLoading: true
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_LOADED() {
      return {
        isLoading: false,
        data: action.mostCreativePeopleCommunitySectionNext
      };
    },
    MOST_CREATIVE_PEOPLE_COMMUNITY_SECTION_NEXT_ERROR() {
      return {
        isLoading: false,
        error: true,
        errorMessage: action.mostCreativePeopleCommunitySectionNext.errorMessage
      };
    }
  };

  if (typeMap[action.type]) {
    return typeMap[action.type]();
  }

  return state;
}
